export const DATE_TIME_FIELDS: string[] = [
    'dateTime',
    'loadingDate',
    'userCreationDate',
    'lastLoginDate',
    'updateDate',
    'paymentDate',
    'notificationDate'
];

export const DATE_TIME_FORMAT = 'dd/MM/yy - HH:mm.ss';
export const DATE_FORMAT = 'dd/MM/yy';

